import Resource from '@/api/resource'
import request from '@/utils/request'

class Categories extends Resource {
  constructor() {
    super('categories')
  }

  list(query) {
    return request({
      url: `${this.uri}/index`,
      method: 'POST',
      data: query,
    })
  }

  put(query) {
    return request({
      url: `/${this.uri}/store`,
      method: 'post',
      data: query,
    })
  }

  update(payload) {
    return request({
      url: `/${this.uri}/update/${payload.id}`,
      method: 'post',
      data: payload.query,
    })
  }

  get(id) {
    return request({
      url: `/${this.uri}/show/${id}`,
      method: 'get',
    })
  }

  delete(id) {
    return request({
      url: `/${this.uri}/${id}`,
      method: 'delete',
    })
  }

  lookups() {
    return request({
      url: `${this.uri}/lookups`,
      method: 'get',
    })
  }
}

export { Categories as default }
